import React, { useEffect, useState } from 'react';
import { Col, FloatingLabel, Form, Modal, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { GenerateYearRange, months } from '../../../util/helper';
import FilesRender from '../../../components/atoms/FilesRender';
import { post, put } from '../../../services/apiController';

const MonthlyInvoiceUpload = ({ monthlyInvoiceId, data, open, onClose, callback }) => {
  const [form, setForm] = useState({
    month: '',
    year: '',
    rentAmount: 0,
    waterAmount: 0,
    maintenanceAmount: 0,
  });

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    setForm({ ...form, [name]: files[0] });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  const yearRange = GenerateYearRange(data.effectiveDate, data.agreementEndDate);

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append('agreementId', data?.id);
    for (const key in form) {
      formData.append(key, form[key]);
    }
    if (monthlyInvoiceId) {
      put(formData, `/agreements/invoices/${monthlyInvoiceId}`, false)
        .then((res) => {
          toast.success(res?.data?.message);
          onClose();
          callback();
        })
        .catch((err) => toast.error(err?.response?.data?.data?.message || err?.message));
    } else {
      post(formData, '/agreements/invoices', false)
        .then((res) => {
          toast.success(res?.data?.message);
          onClose();
          callback();
        })
        .catch((err) => toast.error(err?.response?.data?.data?.message || err?.message));
    }
  };

  useEffect(() => {
    if (monthlyInvoiceId) {
      const monthly_invoices_details = data.MonthlyInvoices.find((item) => item.id === +monthlyInvoiceId);
      if (monthly_invoices_details) {
        setForm({
          month: monthly_invoices_details.month,
          year: monthly_invoices_details.year,
          rentAmount: monthly_invoices_details.rentAmount,
          waterAmount: monthly_invoices_details.waterAmount,
          maintenanceAmount: monthly_invoices_details.maintenanceAmount,
          rentInvoice: monthly_invoices_details.rentInvoice,
          waterInvoice: monthly_invoices_details.waterInvoice,
          maintenanceInvoice: monthly_invoices_details.maintenanceInvoice,
        });
      }
    }
  }, [monthlyInvoiceId]);

  return (
    <Modal size="lg" show={open} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>Upload Monthly Invoices</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={6}>
            <FloatingLabel controlId="floatingSelect" label="Month" className="mb-3">
              <Form.Select required value={form.month} name="month" onChange={handleChange} className="input">
                <option value="">Select Month</option>
                {Array.from({ length: 12 }).map((_, index) => (
                  <option key={index} value={index + 1}>
                    {months[index + 1]}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col xs={6}>
            <FloatingLabel controlId="floatingSelect" label="Year" className="mb-3">
              <Form.Select required value={form.year} name="year" onChange={handleChange} className="input">
                <option value="">Select Year</option>
                {yearRange.map((year, index) => (
                  <option key={index} value={year}>
                    {year}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col xs={6}>
            <FloatingLabel controlId="floatingInput" label="Rent Amount" className="mb-3">
              <Form.Control
                className="input"
                name="rentAmount"
                value={form.rentAmount}
                onChange={handleChange}
                type="number"
                placeholder="Rent Amount"
              />
            </FloatingLabel>
          </Col>
          <Col xs={6}>
            <Form.Label>Upload Rent Invoice</Form.Label>
            <Form.Control className="input mb-3" name="rentInvoice" onChange={handleFileChange} type="file" autoComplete="false" />
            {FilesRender(form['rentInvoice'])}
          </Col>
          <Col xs={6}>
            <FloatingLabel controlId="floatingInput" label="Water Charge Amount" className="mb-3">
              <Form.Control
                className="input"
                name="waterAmount"
                value={form.waterAmount}
                onChange={handleChange}
                type="number"
                placeholder="Water Charge Amount"
              />
            </FloatingLabel>
          </Col>
          <Col xs={6}>
            <Form.Label>Upload Water Bill Invoice</Form.Label>
            <Form.Control className="input mb-3" name="waterInvoice" onChange={handleFileChange} type="file" autoComplete="false" />
            {FilesRender(form['waterInvoice'])}
          </Col>
          <Col xs={6}>
            <FloatingLabel controlId="floatingInput" label="Maintenance Amount" className="mb-3">
              <Form.Control
                className="input"
                name="maintenanceAmount"
                value={form.maintenanceAmount}
                onChange={handleChange}
                type="number"
                placeholder="Maintenance Amount"
              />
            </FloatingLabel>
          </Col>
          <Col xs={6}>
            <Form.Label>Upload Maintenance Invoice</Form.Label>
            <Form.Control className="input mb-3" name="maintenanceInvoice" onChange={handleFileChange} type="file" autoComplete="false" />
            {FilesRender(form['maintenanceInvoice'])}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <div className="btn-wrapper">
          <button onClick={onClose} className="btn app-btn-default btn-sm">
            Cancel
          </button>
          <button onClick={handleSubmit} className="btn app-btn-primary btn-sm">
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MonthlyInvoiceUpload;
